const PUSH_REASON_LABELS = {
  no_eligible_ios_token: 'No active iOS device registered',
  token_lookup_failed: 'Device registration lookup failed',
  template_missing: 'Push message template unavailable',
  noop_provider_selected: 'Push provider unavailable',
  provider_failure: 'Push provider rejected the request',
};

export const getReadablePushReason = (reason) => {
  if (!reason) return '';
  return PUSH_REASON_LABELS[reason] || 'Push could not be completed';
};

export const getPushOutcomeLabel = (entry) => {
  if (entry.status === 'provider_accepted') return 'APNs accepted';
  if (entry.status === 'sent' && !entry.push_audit?.provider_response) {
    return 'Provider outcome not recorded';
  }
  if (entry.push_audit?.failure_stage) return 'Push not completed';
  return 'Awaiting provider';
};

export const appendNotificationAuditFilters = (params, filters) => {
  if (filters.channel) params.append('channel', filters.channel);
  if (filters.status) params.append('status', filters.status);
  if (filters.event_type) params.append('event_type', filters.event_type);
  if (filters.recipient) params.append('recipient', filters.recipient);
  if (filters.game_id) params.append('game_id', filters.game_id);
  if (filters.start_date) {
    params.append('start_date', new Date(filters.start_date).toISOString());
  }
  if (filters.end_date) {
    params.append('end_date', new Date(filters.end_date).toISOString());
  }
  return params;
};
